import * as actions from './actions';
import { responseStatus } from '../../utils/constants';

export type State = {
  tempScenario: Record<string, any>;
  modelledScenario: Record<string, any>;
  updatedFields: Record<string, any>;
  error: Record<string, any>;
  deleteSpouse?: string;
};

const initialState = {
  tempScenario: {},
  modelledScenario: {},
  updatedFields: {},
  error: {},
};

export default (state: State = initialState, action: any): State => {
  switch (action.type) {
    case actions.SET_INITIAL_STATE_FOR_SPOUSE_DATA:
      return {
        ...state,
        tempScenario: {
          ...action.payload,
        },
        modelledScenario: {
          ...action.payload,
        },
        updatedFields: {},
      };
    case actions.UPDATE_SPOUSE_DATA:
      return {
        ...state,
        tempScenario: {
          ...state.tempScenario,
          ...action.payload,
        },
        updatedFields: {
          ...state.updatedFields,
          ...action.payload,
        },
      };
    case actions.MODEL_SPOUSE_DATA:
      return {
        ...state,
        modelledScenario: state.tempScenario,
      };
    case actions.UPDATE_SPOUSE_ERROR:
      return {
        ...state,
        error: {
          ...state.error,
          ...action.payload,
        },
      };
    case actions.DELETE_SPOUSE:
      return {
        ...state,
        deleteSpouse: 'inProgress',
      };

    case actions.DELETE_SPOUSE_SUCCESS:
      return {
        ...state,
        deleteSpouse: responseStatus.SUCCESS,
      };

    case actions.DELETE_SPOUSE_ERROR:
      return {
        ...state,
        deleteSpouse: responseStatus.ERROR,
      };
    default:
      return state;
  }
};
